import * as React from 'react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react';

type ChangeHandler = (value: number) => void;

type ContractPartTimeMonthBlockProps = {
    onChange: ChangeHandler;
    value?: number;
    className?: string;
    disabled?: boolean;
};

export class ContractPartTimeMonthBlock extends React.PureComponent<ContractPartTimeMonthBlockProps,{}>{
    private _store: ContractPartTimeMonthBlockStore;

    constructor(props: ContractPartTimeMonthBlockProps) {
        super(props);
        this._store = new ContractPartTimeMonthBlockStore(props);
    }
    
    render(){
        return(
            <Dropdown
                label="Contract Definition"
                options={this._store.monthContractDefinitionOptions}
                onChange={this._store.onChangeContractDefinition}
                selectedKey={this.props.value}
                required
                className={this.props.className}
                disabled={this.props.disabled}
            />
        );
    }
}

class ContractPartTimeMonthBlockStore {
    private readonly _onChange: ChangeHandler;

    constructor(props: ContractPartTimeMonthBlockProps) {
        this._onChange = props.onChange;
    }

    onChangeContractDefinition = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            this._onChange(option.key as number);
        }
    };

    public get monthContractDefinitionOptions() {
        return [
            {key: 6, text: '6'},
            {key: 7, text: '7'},
            {key: 8, text: '8'},
            {key: 9, text: '9'},
            {key: 10, text: '10'},
            {key: 11, text: '11'}
        ];
    }
}